<template>
	<div ref="viewEditorWrapper">
		
		<div class="font-weight-medium ml-3">View template</div>
		<v-form ref="form" >
			<v-text-field
				class="mx-3 mt-6"
				label="Name"
				v-model="docData.name"
				:rules="agile.fieldRules.nameRules"
				outlined
				dense
			></v-text-field>
			<v-text-field
				class="mx-3 mt-n2"
				label="Code class name"
				v-model="docData.className"
				:rules="agile.fieldRules.nameRules"
				outlined
				dense
			></v-text-field>
		</v-form>

		<!-- -------------------------------------------- -->
		<!--   Description and settings expansion panel -->
		<!-- -------------------------------------------- -->

		<v-expansion-panels multiple class="mx-3 pr-6 pb-6">
			
			<v-expansion-panel>

				<!-- Expanded panel header-->
				<v-expansion-panel-header color="grey lighten-4 primary--text text--darken-1">
					<b>Template description</b>
				</v-expansion-panel-header>

				<!-- Expanded panel -->
				<v-expansion-panel-content eager>
					<v-textarea
						class="pt-7 pb-0 mb-n4"
						label="Optionally enter text describing this view"
						v-model="docData.description"
						auto-grow
						outlined
						rows="3"
						row-height="25"
					></v-textarea>
				</v-expansion-panel-content>
			</v-expansion-panel>


			<v-expansion-panel>

				<!-- Expanded panel header-->
				<v-expansion-panel-header color="grey lighten-4 primary--text text--darken-1">
					<b>Template settings</b>
				</v-expansion-panel-header>

				<!-- Expanded panel -->
				<v-expansion-panel-content eager>
					<views-editor-settings :id="id" :doc-data="docData"/>
				</v-expansion-panel-content>
			</v-expansion-panel>

		</v-expansion-panels>


		<!-- -------------------------------------------- -->
		<!--   Groups repeater entry -->
		<!-- -------------------------------------------- -->

		<div class="pb-6" v-for="(group, i) in docData.groups" :key="i">
			<v-toolbar
				class="mt-6"
				dense
				flat
				color="boxOnBrightBackground"
			>
				<!-- <div class="font-weight-medium title" style="width: 200px;">{{group.name}}</div> -->
				<v-text-field
					class="ml-n1 mt-3"
					label="Group name"
					v-model="group.name"
					:rules="agile.fieldRules.nameRules"
					outlined
					dense
					
				></v-text-field>
				<v-checkbox
					class="pl-3 mt-2"
					label="Show as card (hides group title)"
					v-model="group.showAsCard"
				></v-checkbox>
				<v-spacer />

				<v-btn v-if="docData.groups.indexOf(group) > 0" icon small color="#888888" @click.stop.prevent="moveGroupUp(group)">
					<v-icon>mdi-arrow-up-bold-circle-outline</v-icon>
				</v-btn>
				<v-btn v-if="docData.groups.indexOf(group) < docData.groups.length-1" icon  small color="#888888" @click.stop.prevent="moveGroupDown(group)">
					<v-icon>mdi-arrow-down-bold-circle-outline</v-icon>
				</v-btn>
				<v-btn icon class="mr-3 ml-2" small color="#888888" @click.stop.prevent="deleteGroup(group)">
					<v-icon>mdi-delete-circle-outline</v-icon>
				</v-btn>

				<v-btn class="mr-0" width="120" small color="secondary" @click="createField(group)">
					Create field
				</v-btn>
				
			</v-toolbar>
			


			<!-- -------------------------------------------- -->
			<!--   Grups expansion panel -->
			<!-- -------------------------------------------- -->

			<v-expansion-panels multiple class="mx-3 pr-6">
				
				<!-- -------------------------------------------- -->
				<!--   Data field entries in expansion panel -->
				<!-- -------------------------------------------- -->

				<v-expansion-panel v-for="(field, i) in group.fields" :key="i">

					<!-- Expanded panel header-->
					<v-expansion-panel-header color="grey lighten-4 primary--text text--darken-1">
						<div>
							<v-btn v-if="group.fields.indexOf(field) > 0" style="position: absolute; left: 5px; top: 5px;" icon class="mmr-0" x-small color="#cccccc" @click.stop="moveFieldUp(group, field)">
								<v-icon>mdi-arrow-up-bold</v-icon>
							</v-btn>
							<v-btn v-if="group.fields.indexOf(field) < group.fields.length-1" style="position: absolute; left: 5px; top: 23px;" icon class="mmr-0" x-small color="#cccccc" @click.stop="moveFieldDown(group, field)">
								<v-icon>mdi-arrow-down-bold</v-icon>
							</v-btn>
							<div class="font-weight-bold ml-3">{{field.name}}</div>
							<v-btn style="position: absolute; top: 14px; right: 80px;" icon class="mmr-0" x-small color="#aaaaaa" @click.stop="deleteField(group, field)">
								<v-icon>mdi-trash-can</v-icon>
							</v-btn>
						</div>
					</v-expansion-panel-header>

					<!-- Expanded panel -->
					<v-expansion-panel-content>
						
						<v-row>
							<v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4" class="px-3 pt-0 pb-0">
								
								<v-row>
									<v-col cols="12" xs="12" sm="12" md="12" class="py-0">
										<v-text-field
											class="mx-3 mt-9"
											label="Name"
											v-model="field.name"
											:rules="agile.fieldRules.nameRules"
											outlined
											dense
										></v-text-field>
									</v-col>
									
									<v-col cols="12" xs="12" sm="12" md="12" class="py-0 mt-n2">
										<v-select
											class="mx-3"
											:items="fieldTypes"
											v-model="field.fieldTypeChosen"
											item-text="name"
											item-value="fieldType"
											label="Field type"
											v-on:change="changeFieldType(field)"
											outlined
											dense
										></v-select>
									</v-col>
									
								</v-row>
							</v-col>

							<v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4" class="px-3 pt-0 pb-0">
								
								<v-row>
									<v-col cols="12" xs="12" sm="12" md="12" class="py-0 mt-9">
										<v-text-field
											class="mx-3"
											label="Code property name"
											v-model="field.propertyName"
											:rules="agile.fieldRules.nameRules"
											outlined
											dense
										></v-text-field>
									</v-col>
									<v-col cols="12" xs="12" sm="12" md="12" class="py-0 mt-n2">
										<v-text-field
											class="mx-3"
											label="Tool tip"
											v-model="field.toolTip"
											:rules="agile.fieldRules.nameRules"
											outlined
											dense
										></v-text-field>
									</v-col>
								</v-row>
							</v-col>


							<v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4" class="px-3 pt-0 pb-0">
								
								<v-row>
									<v-col cols="12" xs="12" sm="12" md="12" class="py-0">
										<v-checkbox
											cols="12" xs="12" sm="12" md="3"
											class="mx-3 pt-2 mt-7"
											label="Show only for developers"
											v-model="field.developersOnly"
										></v-checkbox>
									</v-col>
									<v-col cols="12" xs="12" sm="12" md="12" class="py-0">
										<v-checkbox
											cols="12" xs="12" sm="12" md="3"
											class="mx-3 pt-0 mt-n2 mt-0"
											label="Accessible at runtime"
											v-model="field.accessibleAtRuntime"
										></v-checkbox>
									</v-col>
									<v-col cols="12" xs="12" sm="12" md="12" class="py-0">
										<v-checkbox
											cols="12" xs="12" sm="12" md="3"
											class="mx-3 pt-0 mt-n2"
											label="Overridable by shared instances"
											v-model="field.overridableBySharedInstances"
										></v-checkbox>
									</v-col>
									<v-col cols="12" xs="12" sm="12" md="12" class="py-0">
										<v-checkbox
											cols="12" xs="12" sm="12" md="3"
											class="mx-3 pt-0 mt-n2"
											label="Include in search"
											v-model="field.includeFieldInSearch"
										></v-checkbox>
									</v-col>
								</v-row>
							</v-col>

							
						</v-row>



						<v-row>
							<v-col cols="12" xs="12" sm="12" md="12" xl="12" class="px-3 pt-0 pb-0 mt-2">
								<div class="font-weight-medium">{{field.typeProperties.name}} properties</div>
								<v-divider/>
							</v-col>
						</v-row>

						<!-- -------------------------------------------- -->
						<!--   Datafield type components -->
						<!-- -------------------------------------------- -->

						<keep-alive>
							<component ref="dataTypeComponent" :fieldTypes="fieldTypes" :field="field" :is="field.typeProperties.uiComponent" />
						</keep-alive>
						
					</v-expansion-panel-content>
				</v-expansion-panel>

			</v-expansion-panels>
		</div>

		<!-- Save button -->
		<v-toolbar flat elevation-1 class="ml-n4 pl-0" style="background: rgba(255, 255, 255, 0.0) !important;">
				
		<v-btn class="ml-3 mb-3 mt-8" @click="saveDocumentToFirestore">
			Save
		</v-btn>
		
			<v-spacer/>
			<!-- Add group button -->
			<v-btn class="ml-3 mb-3 mt-8 mr-n4" width="120" small color="secondary" @click="createGroup">
				Create group
			</v-btn>
		</v-toolbar>
	</div>
</template>


<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from "@/shift/agile";
import fb from '@/shift/fb';
import ViewsEditorSettings from '@/components/viewseditor/ViewsEditorSettings';

import ViewTextField from '@/components/viewseditor/fieldtypes/ViewTextField';
import ViewTextAreaField from '@/components/viewseditor/fieldtypes/ViewTextAreaField';
import ViewNumberField from '@/components/viewseditor/fieldtypes/ViewNumberField';
import ViewIntegerField from '@/components/viewseditor/fieldtypes/ViewIntegerField';
import ViewBooleanField from '@/components/viewseditor/fieldtypes/ViewBooleanField';
import ViewTableField from '@/components/viewseditor/fieldtypes/ViewTableField';
import ViewCustomObjectsField from '@/components/viewseditor/fieldtypes/ViewCustomObjectsField';
import ViewRichTextEditorField from '@/components/viewseditor/fieldtypes/ViewRichTextEditorField';
import ViewSimpleFileField from '@/components/viewseditor/fieldtypes/ViewSimpleFileField';
import ViewDynamicField from '@/components/viewseditor/fieldtypes/ViewDynamicField';
import ViewSimpleImageField from '@/components/viewseditor/fieldtypes/ViewSimpleImageField';
import ViewSimpleVideoField from '@/components/viewseditor/fieldtypes/ViewSimpleVideoField';

import ViewFieldVO from '@/valueobjects/viewseditor/ViewFieldVO';
import ViewTextFieldVO from '@/valueobjects/viewseditor/ViewTextFieldVO';
import ViewTextAreaVO from '@/valueobjects/viewseditor/ViewTextAreaVO';
import ViewNumberVO from '@/valueobjects/viewseditor/ViewNumberVO';
import ViewIntegerVO from '@/valueobjects/viewseditor/ViewIntegerVO';
import ViewBooleanVO from '@/valueobjects/viewseditor/ViewBooleanVO';
import ViewTableVO from '@/valueobjects/viewseditor/ViewTableVO';
import ViewCustomObjectsVO from '@/valueobjects/viewseditor/ViewCustomObjectsVO';
import ViewRichTextEditorVO from '@/valueobjects/viewseditor/ViewRichTextEditorVO';
import ViewSimpleFileVO from '@/valueobjects/viewseditor/ViewSimpleFileVO';
import ViewDynamicVO from '@/valueobjects/viewseditor/ViewDynamicVO';
import ViewSimpleImageVO from '@/valueobjects/viewseditor/ViewSimpleImageVO';
import ViewSimpleVideoVO from '@/valueobjects/viewseditor/ViewSimpleVideoVO';



export default
{
	name: 'ViewsEditTemplate',
	components:
	{
		ViewsEditorSettings,
		ViewTableField,
		ViewCustomObjectsField,
		ViewTextField,
		ViewTextAreaField,
		ViewNumberField,
		ViewIntegerField,
		ViewBooleanField,
		ViewRichTextEditorField,
		ViewSimpleFileField,
		ViewDynamicField,
		ViewSimpleImageField,
		ViewSimpleVideoField,
	},

	props:
	{
		id: { type: String },
		name: { type: String },
		docData: { type: Object }
	},
	
    data: () =>
    ({
		label: '',
		allowFirestoreSave: true,
		
		
		fieldTypes:
		[
			{
				name: 'Textfield',
				fieldType: 'textField',
				uiComponent: 'view-text-field'
			},
			{
				name: 'Textarea',
				fieldType: 'textArea',
				uiComponent: 'view-text-area-field'
			},
			{
				name: 'Rich text editor',
				fieldType: 'richTextEditor',
				uiComponent: 'view-rich-text-editor-field'
			},
			{
				name: 'Checkbox',
				fieldType: 'boolean',
				uiComponent: 'view-boolean-field'
			},
			{
				name: 'Simple image',
				fieldType: 'simpleImage',
				uiComponent: 'view-simple-image-field'
			},
			{
				name: 'Video',
				fieldType: 'simpleVideo',
				uiComponent: 'view-simple-video-field'
			},
			/* {
				name: 'Image',
			},
			{
				name: 'Video',
			},
			{
				name: 'File',
			},
			{
				name: 'File list',
			}, */
			{
				name: 'Simple file',
				fieldType: 'simpleFile',
				uiComponent: 'view-simple-file-field'
			},
			{
				name: 'Table',
				fieldType: 'table',
				uiComponent: 'view-table-field'
			},
			{
				name: 'Number',
				fieldType: 'number',
				uiComponent: 'view-number-field'
			},
			{
				name: 'Integer',
				fieldType: 'integer',
				uiComponent: 'view-integer-field'
			},
			{
				name: 'Custom objects',
				fieldType: 'customObjects',
				uiComponent: 'view-custom-objects-field'
			},
			{
				name: 'Dynamic field',
				fieldType: 'dynamicField',
				uiComponent: 'view-dynamic-field'
			},
		]

    }),

    computed:
	{
        agile()
        {
            return agile;
		},
		
		routeKey()
		{
			return this.$route.params.key;
		},
	},

	created()
	{
		
		this.label = this.name;
		if (!this.docData.className) this.docData.className = agile.toJsSafeProperCaseNoNumbers(this.name);
	},

    mounted()
    {
		// Save document when pressing "Ctrl+S"
        document.addEventListener("keydown", this.onKeyPressSave);
    },

    methods:
    {
		changeFieldType(field)
		{
			switch (field.fieldTypeChosen)
			{
				case 'textField': field.typeProperties = agile.convertPropertiesToPlainObject(new ViewTextFieldVO()); break;
				case 'textArea': field.typeProperties = agile.convertPropertiesToPlainObject(new ViewTextAreaVO()); break;
				case 'boolean': field.typeProperties = agile.convertPropertiesToPlainObject(new ViewBooleanVO()); break;
				case 'table': field.typeProperties = agile.convertPropertiesToPlainObject(new ViewTableVO()); break;
				case 'number': field.typeProperties = agile.convertPropertiesToPlainObject(new ViewNumberVO()); break;
				case 'integer': field.typeProperties = agile.convertPropertiesToPlainObject(new ViewIntegerVO()); break;
				case 'customObjects': field.typeProperties = agile.convertPropertiesToPlainObject(new ViewCustomObjectsVO()); break;
				case 'richTextEditor': field.typeProperties = agile.convertPropertiesToPlainObject(new ViewRichTextEditorVO()); break;
				case 'simpleFile': field.typeProperties = agile.convertPropertiesToPlainObject(new ViewSimpleFileVO()); break;
				case 'dynamicField': field.typeProperties = agile.convertPropertiesToPlainObject(new ViewDynamicVO()); break;
				case 'simpleImage': field.typeProperties = agile.convertPropertiesToPlainObject(new ViewSimpleImageVO()); break;
				case 'simpleVideo': field.typeProperties = agile.convertPropertiesToPlainObject(new ViewSimpleVideoVO()); break;
			}

		},

		createGroup()
		{
			this.$root.$setName('Name of group') // Open dialog box to set name
			.then((nameReturned) =>
			{
				if (nameReturned)
				{
					if (!this.docData.groups) this.docData.groups = [];
					this.docData.groups.push( { name: nameReturned, fields: [], showAsCard: false } );
				}
			});
			
		},



		createField(group)
		{
			this.$root.$setName('Name of field') // Open dialog box to set name
			.then((nameReturned) =>
			{
				if (nameReturned)
				{
					if (!group.fields) group.fields = [];
					
					const newField = agile.convertPropertiesToPlainObject(new ViewFieldVO());
					newField.name = nameReturned;
					newField.typeProperties = agile.convertPropertiesToPlainObject(new ViewTextFieldVO());

					newField.propertyName = agile.toJsSafeCamelCase(nameReturned);

					group.fields.push( newField );
				}
			});
			
		},



		// --------------------------------------------------------------------
		//
		//	Group commands
		//
		// --------------------------------------------------------------------

		deleteGroup(group)
		{
			this.$root.$confirm('Deleting group', 'All the containing fields will also be deleted! Do you really want to delete field type?', { color: 'error' } )
			.then((confirm) =>
			{
				if (confirm)
				{
					const currentPos = this.docData.groups.indexOf(group);
					this.docData.groups.splice(currentPos, 1);
				}
			});
		},

		moveGroupUp(group)
		{
			const currentPos = this.docData.groups.indexOf(group);

			if (currentPos < this.docData.groups.length)
			{
				this.docData.groups.splice(currentPos, 1);
				this.docData.groups.splice(currentPos-1, 0, group);
			}
		},

		moveGroupDown(group)
		{
			const currentPos = this.docData.groups.indexOf(group);

			if (currentPos < this.docData.groups.length)
			{
				this.docData.groups.splice(currentPos, 1);
				this.docData.groups.splice(currentPos+1, 0, group);
			}
		},



		// --------------------------------------------------------------------
		//
		//	Field commands
		//
		// --------------------------------------------------------------------

		deleteField(group, field)
		{
			this.$root.$confirm('Deleting', 'Do you really want to delete field type?', { color: 'warning' } )
			.then((confirm) =>
			{
				if (confirm)
				{
					const currentPos = group.fields.indexOf(field);
					group.fields.splice(currentPos, 1);
				}
			});
		},

		moveFieldUp(group, field)
		{
			const currentPos = group.fields.indexOf(field);

			if (currentPos > 0)
			{
				group.fields.splice(currentPos, 1);
				group.fields.splice(currentPos-1, 0, field);
			}
		},

		moveFieldDown(group, field)
		{
			const currentPos = group.fields.indexOf(field);

			if (currentPos < group.fields.length)
			{
				group.fields.splice(currentPos, 1);
				group.fields.splice(currentPos+1, 0, field);
			}
		},



		




		onKeyPressSave(e)
		{
			if (!(e.keyCode === 83 && e.ctrlKey))
			{
				return;
			}

			// Make sure we are only saving this document, and not other documents open in the tab menu (thye are hidden).
			// This code below checks if the component is wrapped in an element with display: none; or not
			// Not foolproof though: https://stackoverflow.com/questions/19669786/check-if-element-is-visible-in-dom

			if (this.$refs.viewEditorWrapper.offsetParent)
			{
				this.saveDocumentToFirestore();
			}
			
			e.preventDefault();
			
		},


		// --------------------------------------------------------------------
		//
		//	Save document to Firestore
		//
		// --------------------------------------------------------------------

		saveDocumentToFirestore()
		{
			if (this.$refs.form.validate())
			{
				if (this.allowFirestoreSave)
				{
					this.allowFirestoreSave = false;

					const doc = fb.db
						.collection('dev-collection')
						.doc('dev-doc')
						.collection(this.routeKey)
						.doc(this.routeKey)
						.collection('view-templates')
						.doc(this.id);


					doc.set( this.docData, { merge: true } )
					.then(() =>
					{
						this.$root.ai_app.snackbarText = `Saved template ${this.name}`;
						this.$root.ai_app.snackbarTimeout = 4000;
						this.$root.ai_app.snackbar = true;
						//console.log("Updated View Tamplate", this.label);
					})
					.catch((er) =>
					{
						this.$root.$alert("Error updating", er.message);
					});


					// Protection against spamming firestore, i.e. if the user keeps holding Ctrl+S down
					
					setTimeout(() =>
					{
						this.allowFirestoreSave = true;
					}, 1000);
				}
				
			}
		},
	},
	


	beforeDestroy()
	{
		document.removeEventListener("keydown", this.onKeyPressSave);
	},

}

</script>
